<nz-modal [(nzVisible)]="isVisible" nzTitle="Add New Supplier" (nzOnCancel)="handleCancel()" (nzOnOk)="handleOk()">
  <ng-container *nzModalContent>
    <section id="supplierDetails">
      <nz-card>
        <div>
          <h5 class="text-primary">Supplier Details</h5>
          <form nz-form [formGroup]="suppliersForm" [nzLayout]="'vertical'">
            <div class="mt-5 grid md:grid-cols-1">

              <div class="grid sm:grid-cols-1" formGroupName="supplierDetails">

                <nz-form-item class="grid grid-flow-row content-start">
                  <nz-form-label nzFor="name" nzRequired>Supplier Name</nz-form-label>
                  <nz-form-control [nzErrorTip]="nameSupplier">
                    <input nz-input type="text" [maxLength]="70" (ngModelChange)="updateAccountHolderName()"
                           formControlName="name" placeHolder="Enter Full Name"/>
                  </nz-form-control>
                  <ng-template #nameSupplier>
                <span
                  *ngIf="suppliersForm.get('supplierDetails.name').hasError('required')">Please enter Supplier Name</span>
                    <span *ngIf="suppliersForm.get('supplierDetails.name').hasError('maxlength')">
                  Maximum length is 70 characters</span>
                    <span *ngIf="suppliersForm.get('supplierDetails.name').hasError('pattern')">
                  Only allowed letters, please avoid adding special characters or numbers</span>
                  </ng-template>
                </nz-form-item>

              </div>


              <div class="grid" formGroupName="supplierDetails">

                <nz-form-item class="grid grid-flow-row content-start"
                              [ngClass]="{'has-error': suppliersForm.get('supplierDetails.mobileNo').invalid && suppliersForm.get('supplierDetails.mobileNo').touched}">
                  <nz-form-label nzFor="mobileNo" nzRequired>Supplier Mobile Number</nz-form-label>
                  <nz-form-control [nzErrorTip]="mobileNo">
                    <input nz-input type="text" formControlName="mobileNo" [maxLength]="15"
                           placeHolder="Enter Mobile Number"/>
                  </nz-form-control>
                  <ng-template #mobileNo>
                    <span *ngIf="suppliersForm.get('supplierDetails.mobileNo').hasError('required')">Please Enter Mobile Number</span>
                    <span *ngIf="suppliersForm.get('supplierDetails.mobileNo').hasError('maxlength')"> Maximum length is 15 characters</span>
                    <span *ngIf="suppliersForm.get('supplierDetails.mobileNo').hasError('pattern')">Only allowed numbers, please avoid adding special characters or letters</span>
                  </ng-template>
                </nz-form-item>

                <nz-form-item class="grid grid-flow-row content-start"
                              [ngClass]="{'has-error': suppliersForm.get('supplierDetails.email').invalid && suppliersForm.get('supplierDetails.email').touched || this.emailExists}">
                  <nz-form-label nzFor="email" nzRequired>Supplier Email</nz-form-label>
                  <nz-form-control [nzErrorTip]="email">
                    <input nz-input type="text" formControlName="email" placeHolder="Enter Supplier Email"/>
                  </nz-form-control>
                  <ng-template #email>
                    <span
                      *ngIf="suppliersForm.get('supplierDetails.email').hasError('required')">Please Enter Email</span>
                    <span *ngIf="suppliersForm.get('supplierDetails.email').hasError('maxlength')">Maximum length is 100 characters</span>
                    <span
                      *ngIf="suppliersForm.get('supplierDetails.email').hasError('email') && suppliersForm.get('supplierDetails.email').touched">Invalid email address, please review your input.</span>
                    <span *ngIf="this.emailExists">Email address already exists. Select another email.</span>
                  </ng-template>
                </nz-form-item>


              </div>

            </div>
          </form>
        </div>
      </nz-card>
    </section>


    <section id="paymentInformation" class="mt-8">
      <nz-card>
        <div>
          <h5 class="text-primary">Payment Details</h5>

          <form nz-form [formGroup]="suppliersForm" [nzLayout]="'vertical'">

            <div class="mt-5 grid gap-8">

              <div class="grid" formGroupName="paymentDetails">

                <nz-form-item class="grid grid-flow-row content-start">
                  <nz-form-label nzFor="bankName">Bank Name</nz-form-label>
                  <nz-form-control>
                    <input nz-input type="text" formControlName="bankName" placeHolder="Enter Name"/>
                  </nz-form-control>

                </nz-form-item>

                <nz-form-item class="grid grid-flow-row content-start">
                  <nz-form-label nzFor="branch">Branch Name</nz-form-label>
                  <nz-form-control>
                    <input nz-input type="text" formControlName="branch" placeHolder="Enter Name"/>
                  </nz-form-control>
                </nz-form-item>

              </div>
            </div>

            <div class=" grid" formGroupName="paymentDetails">

              <nz-form-item class="grid grid-flow-row content-start">
                <nz-form-label nzFor="accountType">Account Type</nz-form-label>
                <nz-form-control>
                  <nz-select
                    nzPlaceHolder="Select Account Type"
                    formControlName="accountType"
                  >
                    <nz-option nzValue="Current Account" nzLabel="Current Account"></nz-option>
                    <nz-option nzValue="Savings Account" nzLabel="Savings Account"></nz-option>
                  </nz-select>
                </nz-form-control>
              </nz-form-item>


              <nz-form-item class="grid grid-flow-row content-start">
                <nz-form-label nzFor="holderName">Account Holder Name</nz-form-label>
                <nz-form-control [nzErrorTip]="holderName">
                  <input nz-input type="text" [maxLength]="70" formControlName="holderName"
                         placeHolder="Enter Account Holder Name"/>
                </nz-form-control>
                <ng-template #holderName>
                  <span *ngIf="suppliersForm.get('paymentDetails.holderName').hasError('pattern')">Only allowed letters, please avoid adding special characters or numbers</span>
                </ng-template>
              </nz-form-item>


              <nz-form-item class="grid grid-flow-row content-start">
                <nz-form-label nzFor="accountNo">Account Number</nz-form-label>
                <nz-form-control [nzErrorTip]="accountNo">
                  <input nz-input type="text" [maxLength]="70" formControlName="accountNo"
                         placeHolder="Enter Account Number"/>
                </nz-form-control>
                <ng-template #accountNo>
                  <span *ngIf="suppliersForm.get('paymentDetails.accountNo').hasError('pattern')">Only allowed numbers, please avoid adding special characters or letters</span>
                </ng-template>
              </nz-form-item>
            </div>

            <div class="grid gap-8">
              <div class="grid">

                <div>
                  <p class="pb-[8px] font-normal">Attachments</p>

                  <div class="flex flex-col items-center justify-center bg-slate-100 w-full h-32 xl:h-52 py-2">
                    <div>
                      <nz-upload
                        [nzCustomRequest]="upload" [nzShowUploadList]="false" [nzMultiple]="false"
                        (click)="paymentFilesUpload()" (cancel)="paymentFilesUploading = false">
                        <button nz-button>
                          <span nz-icon nzType="upload"></span>
                          Click to Upload
                        </button>
                      </nz-upload>
                    </div>
                    <div>
                      <p *ngIf="paymentFilesUploading" class="text-primary my-2">Uploading...</p>
                    </div>
                    <div class="mt-2 overflow-auto">
                      <div *ngFor="let file of paymentFiles; let i = index"
                           class="flex justify-between items-center mx-3 gap-5">
                        <a target="_blank" href="{{file.url}}">{{file.name}}</a>
                        <span nz-icon nzType="close-circle" nzTheme="outline" [nzTheme]="'twotone'"
                              [nzTwotoneColor]="'#ff0000'"
                              class="cursor-pointer" nz-popconfirm
                              nzPopconfirmTitle="Are you sure you want to delete this attachment"
                              (nzOnConfirm)="confirmRemoveAttachment(i)"
                        ></span>
                      </div>
                    </div>
                  </div>

                  <!--              <nz-upload [nzCustomRequest]="upload" [nzShowUploadList]="false" [nzMultiple]="false"-->
                  <!--                         class="flex justify-center items-center bg-slate-100 w-full h-32 xl:h-48">-->
                  <!--                <button nz-button>-->
                  <!--                  <span nz-icon nzType="upload"></span>-->
                  <!--                  Click to Upload-->
                  <!--                </button>-->
                  <!--              </nz-upload>-->
                  <!--              <div *ngFor="let file of paymentFiles;let i = index">-->
                  <!--                <a class="" target="_blank" href="{{file.url}}">{{file.name}} <span nz-icon nzType="close" nz-popconfirm-->
                  <!--                                                                                    nzPopconfirmTitle="Are you sure you want to delete the attachment"-->
                  <!--                                                                                    nzPopconfirmPlacement="bottom"-->
                  <!--                                                                                    (nzOnConfirm)="confirmRemoveAttachment(i)"-->
                  <!--                                                                                    (nzOnCancel)="cancel()"nzTheme="outline"></span></a>-->
                  <!--              </div>-->
                </div>
              </div>
            </div>

          </form>
        </div>
      </nz-card>
    </section>

    <section id="notes" class="mt-8">
      <nz-card>
        <div>
          <h5 class="text-primary">Notes</h5>
          <form nz-form [formGroup]="suppliersForm" [nzLayout]="'vertical'">
            <div class="mt-5 grid gap-8">
              <div formGroupName="notes">
                <nz-form-item>
                  <nz-form-control>
                    <nz-textarea-count [nzMaxCharacterCount]="200">
                <textarea rows="6" nz-input formControlName="note"
                          PlaceHolder="Add Notes here"></textarea>
                    </nz-textarea-count>
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>
          </form>
        </div>
      </nz-card>
    </section>
  </ng-container>
  <ng-container *nzModalFooter>
    <div class="flex justify-end sm:justify-end">
      <a
        nz-popconfirm
        nzPopconfirmTitle="Are you sure you want to cancel this record? you will loose all data."
        nzPopconfirmPlacement="bottom"
        (nzOnConfirm)="confirm()"
        (nzOnCancel)="cancel()"
      >
        <button class="outline-button mr-3" nz-button nzType="default">Cancel</button>
      </a>
      <button
        nz-popconfirm
        nzPopconfirmTitle="Are you sure you want to save the data?"
        nzPopconfirmPlacement="bottom"
        nz-button nzType="primary"
        (nzOnConfirm)="onSubmit()" (nzOnCancel)="cancel()" [disabled]="suppliersForm.invalid">Add Supplier
      </button>
    </div>
  </ng-container>
</nz-modal>
